import { render, staticRenderFns } from "./HistoryData.vue?vue&type=template&id=8b770f3a&"
import script from "./HistoryData.vue?vue&type=script&lang=js&"
export * from "./HistoryData.vue?vue&type=script&lang=js&"
import style0 from "./HistoryData.vue?vue&type=style&index=0&id=8b770f3a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports